import { ComponentType } from 'preact'
import { YogaWidgetBase, InitData } from '../../core'
import { InstructorsWidget } from './InstructorsWidget'

class HoldstyringInstructorsElement extends YogaWidgetBase {
  protected getComponent(): ComponentType<{ initData: InitData }> {
    return InstructorsWidget
  }

  // Supported HTML attributes:
  //   title="..."             — heading above the cards (default: none)
  //   max-items="6"            — show only first N instructors
  //   show-bio="false"         — hide bio paragraph (default: visible)
  //   show-specialties="false" — hide specialty pills (default: visible)
  protected getWidgetProps() {
    const raw = this.getAttribute('max-items')
    return {
      title: this.getAttribute('title') || null,
      maxItems: raw && /^\d+$/.test(raw) ? parseInt(raw, 10) : null,
      showBio: this.getAttribute('show-bio') !== 'false',
      showSpecialties: this.getAttribute('show-specialties') !== 'false',
    }
  }
}

if (!customElements.get('holdstyring-instructors')) {
  customElements.define('holdstyring-instructors', HoldstyringInstructorsElement)
}

export { HoldstyringInstructorsElement }
